import React from "react";
import { getImage, GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const DoctorProfile = ({ profile }) => {
  const doctorImage = getImage(
    profile?.doctorsMeta?.profilePic?.localFile?.childImageSharp
      ?.gatsbyImageData
  );
  return (
    <div className="mb-8 w-full basis-full px-4 lg:w-1/4 lg:basis-1/4">
      <div>
        <GatsbyImage image={doctorImage} alt={profile.title} />
      </div>
      <h3 className="mt-4 mb-0 font-futuraMd text-lg capitalize text-primary">
        {profile.title}
      </h3>
      <p
        dangerouslySetInnerHTML={{ __html: profile.doctorsMeta.designation }}
        className="mb-4 font-futuraMd text-black"
      ></p>
      <Link
        to={profile.uri}
        className="inline-block bg-primary px-8 py-2 text-base capitalize text-white transition-all duration-500 hover:bg-secondary"
      >
        View More
      </Link>
    </div>
  );
};

export default DoctorProfile;
